import { render } from "./WrapperScene.vue?vue&type=template&id=391b1545"
import script from "./WrapperScene.vue?vue&type=script&lang=js"
export * from "./WrapperScene.vue?vue&type=script&lang=js"

import "./WrapperScene.vue?vue&type=style&index=0&id=391b1545&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__